import React from 'react';

const TermsAndConditions = () => {
    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-2xl overflow-hidden border border-slate-200">
                <div className="bg-slate-900 px-8 py-10 text-white">
                    <h1 className="text-3xl font-bold mb-2">Terms & Conditions</h1>
                    <p className="text-slate-400">Effective Date: February 23, 2026</p>
                </div>

                <div className="p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">1. Introduction</h2>
                        <p>
                            Welcome to paperportal.com (the "Website"), which includes the website, mobile site, and any associated applications.
                            The Website is operated by <strong>Paper Portal</strong> ("Company", "we", "us", or "our"), having its registered address at 5 Bibhuti Bhusan Bandopadhay Sarani, Kolkata 700019, West Bengal, India.
                        </p>
                        <p className="mt-4">
                            These Terms and Conditions serve as an electronic record under the Information Technology Act, 2000, and the Intermediary Guidelines 2011.
                            By accessing or using our Website, you agree to be bound by these terms.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">2. Acceptance of Terms</h2>
                        <p>
                            By utilizing our services, you confirm that you are at least 18 years of age or possess legal parental or guardian consent.
                            If you do not agree with any part of these terms, you must immediately discontinue use of the Website and our services.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">3. Operation Domain</h2>
                        <p>
                            The Company operates only within the territory of <strong>India</strong>. Our services are tailored for the Indian market and comply with relevant Indian laws and regulations.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">4. User Responsibilities</h2>
                        <ul className="list-disc ml-6 space-y-2">
                            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                            <li>You agree not to use the Website for any unlawful purposes or to transmit harmful material.</li>
                            <li>You must provide accurate and complete information during registration and usage.</li>
                            <li>You are solely responsible for any content you upload or transmit through the Website.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">5. Intellectual Property</h2>
                        <p>
                            All content on this Website, including text, graphics, logos, icons, images, and software, is the property ofPaper Portal or its content suppliers and is protected by Indian and international copyright laws.
                            Unauthorized use or duplication of this content is strictly prohibited.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">6. Payments & Charges</h2>
                        <p>
                            Certain services on our platform are subject to payments. All fees are quoted in Indian Rupees (INR).
                            By selecting a paid service, you agree to pay the Company the listed charges. Payments are processed through secure third-party gateways.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">7. Limitation of Liability</h2>
                        <p>
                            Under no circumstances shall Paper Portal be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the Website or services.
                            We do not guarantee that the Website will be error-free or uninterrupted.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">8. Third-Party Links</h2>
                        <p>
                            Our Website may contain links to third-party sites that are not controlled by us. We are not responsible for the content or privacy practices of these external websites.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">9. Indemnification</h2>
                        <p>
                            You agree to indemnify and hold harmless Paper Portal, its officers, and employees from any claims, damages, or expenses arising from your violation of these terms or misuse of the Website.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">10. Force Majeure</h2>
                        <p>
                            The Company shall not be liable for any failure to perform its obligations where such failure results from any cause beyond its reasonable control, including acts of God, strikes, technical failures, or governmental actions.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">11. Governing Law & Jurisdiction</h2>
                        <p>
                            These Terms and Conditions shall be governed by and construed in accordance with the laws of <strong>India</strong>.
                            Subject to the above, the courts at <strong>Kolkata, West Bengal</strong> shall have exclusive jurisdiction over any disputes arising out of or in connection with these terms.
                        </p>
                    </section>

                    <section className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                        <h2 className="text-xl font-bold text-slate-900 mb-4">12. Contact Information</h2>
                        <div className="space-y-2 text-sm md:text-base">
                            <p><strong>Company:</strong> Paper Portal</p>
                            <p><strong>Support Email:</strong> payment@paperportal.in</p>
                            <p><strong>Business Email:</strong> helpdesk@paperportal.in</p>
                            <p><strong>Support Phone:</strong> +91 7890 10 4000</p>
                            <p><strong>Business Phone:</strong> +91 7890 20 4000</p>
                            <p><strong>Working Hours:</strong> Monday - Friday (9:00 - 18:00)</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
